<template>
  <div>
    <ReportNavbar v-if="isSalesReportsEnabled" />
    <template v-if="initialized">
      <router-view />
    </template>
    <UnsavedChangesBottomBar
      :hasUpdates="hasUpdates"
      :saveUpdates="reportUpdateStore.saveUpdates"
      @discardUpdates="reportUpdateStore.discardUpdates"
      module="report"
    />
    <UnsavedChangesDialog
      :hasUpdates="hasUpdates"
      :saveUpdates="reportUpdateStore.saveUpdates"
      :withinValidRoutes="isAmongReportRoutes"
      @discardUpdates="reportUpdateStore.discardUpdates"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'

import UnsavedChangesBottomBar from '@/common/components/organisms/UnsavedChangesBottomBar.vue'
import UnsavedChangesDialog from '@/common/components/organisms/UnsavedChangesDialog.vue'
import { useFeatureFlags } from '@/common/composables/useFeatureFlags'
import ReportNavbar from '@/modules/report/components/organisms/ReportNavbar.vue'
import { useReportStore } from '@/modules/report/stores/ReportStore'
import { useReportUpdateStore } from '@/modules/report/stores/ReportUpdateStore'
import { isAmongReportRoutes } from '@/router'

const initialized = ref<boolean>(false)
const reportStore = useReportStore()
onMounted(async function () {
  await reportStore.getSalesReport()
  initialized.value = true
})

const reportUpdateStore = useReportUpdateStore()
const { hasUpdates } = storeToRefs(reportUpdateStore)
const { isSalesReportsEnabled } = useFeatureFlags()
</script>
